import React from "react";
import { boardMembers } from "../../data/content";

const FOTOLAR = [
  "/images/haberler/btso-kahvalti-1.jpg",
  "/images/haberler/btso-kahvalti-2.jpg",
  "/images/haberler/btso-kahvalti-3.jpg",
];

const BtsoHaberSection: React.FC = () => {
  const baskan = boardMembers[0];
  return (
    <section className="py-16 bg-bg-surface border-b border-border-light">
      <div className="w-full px-6 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 bg-brand-bordo/10 text-brand-bordo text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
              <i className="fa-solid fa-newspaper" /> Haber
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-text-primary leading-snug">
              BTSO Başkan Adayı Özer Matlı'yı Ağırladık
            </h2>
          </div>

          {/* Fotoğraf galerisi */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
            {FOTOLAR.map((src, i) => (
              <img
                key={src}
                src={src}
                alt={`BTSO kahvaltı programı ${i + 1}`}
                className="w-full rounded-xl shadow-md object-cover aspect-square"
              />
            ))}
          </div>

          <div className="space-y-4 text-text-muted leading-relaxed text-justify text-sm md:text-base">
            <p>
              Bursa Trabzon Kültür ve Yardımlaşma Derneği olarak, Başkanımız Orhan AYGÜN
              öncülüğünde BTSO Başkan adayı Sayın Özer MATLI ile güzel bir kahvaltı programı
              gerçekleştirdik.
            </p>
            <p>
              Samimi bir ortamda gerçekleştirilen organizasyonumuzda, BTSO Başkan adayı Sayın Özer
              Matlı bizlere projelerini anlatmışlardır.
            </p>
            <p>
              Nazik ziyaretleri ve kıymetli sohbetleriyle bizleri onurlandıran Sayın Özer Matlı ve
              çalışma arkadaşlarına teşekkür ediyor; BTSO seçimlerinde başarılar diliyoruz.
            </p>
          </div>

          {/* Başkan imzası */}
          <div className="flex items-center gap-4 mt-8 pt-6 border-t border-border-light">
            <img
              src="/baskan-foto.jpg"
              alt={baskan.name}
              className="w-14 h-14 rounded-full object-cover border-2 border-brand-bordo/20"
            />
            <div>
              <div className="font-bold text-text-primary text-sm">{baskan.name}</div>
              <div className="text-text-soft text-xs">Bursa Trabzonlular Derneği Başkanı</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BtsoHaberSection;
